var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form_control",attrs:{"id":_vm.question.label,"type":"text","placeholder":_vm.question.placeholder},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }